/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../dashboard/api/controllers/DashboardController',
	'../DashboardAPI',
	'../../features/dashboard/internalAPI/api/InternalAPI',
	'../../features/dashboard/internalAPI/api/impl/Internal',
	'../../features/dashboard/internalAPI/api/deprecated/InternalAPI'
], (APIFactory, Controller, DashboardAPI, InternalAPI, InternalImpl, InternalDeprecatedAPI) => {
	class DashboardAPIImpl extends Controller {
		constructor(options) {
			super(options);

			this.getName = this.getApplicationLabel.bind(this);
			this.getService = this.getGlassCoreSvc.bind(this);
			this.getServiceWhenReady = this.getGlassSvc.bind(this);
			this.getPluginExtension = this.findGlassPlugin.bind(this);
			this.getCollectionExtension = this.findGlassCollection.bind(this);
			this.getConfiguration = this.getAppConfig.bind(this);
			this.openApplication = this.openGlassApplication.bind(this);
			this.closeApplication = this.closeGlassApplication.bind(this);
			this.internalImpl = new InternalImpl(options);
		}

		destroy() {
			super.destroy();
			this.internalImpl.destroy();
		}

		getAPI() {
			return APIFactory.createAPI(this, [DashboardAPI, InternalAPI]);
		}

		getInternalAPI() {
			return APIFactory.createAPIFromSpec([{
				implementation: this,
				interface: InternalAPI
			}, {
				implementation: this.internalImpl,
				interface: InternalDeprecatedAPI
			}]);
		}

		getType() {
			return this.getApplicationName();
		}

		getCanvas() {
			let canvas;
			//TBD: cleanup using DeprecatedCanvas
			if(this.view) {
				canvas = this.view.getDeprecatedCanvas();
			}
			//there are times when getCanvas() gets called early when DeprecatedCanvas is not ready -
			//Canvas feature is created though, so can be used
			if(!canvas){
				canvas = this.featureLoader.getFeature('Canvas');
			}
			return canvas;
		}

		getCanvasWhenReady() {
			return this.view.getDeprecatedCanvasWhenReady();
		}



		getDataSourceList() {
			return Promise.resolve(this.getFeature('DataSources').getDataSourceList());
		}


		getSources() {
			return this.getFeature('DataSources').getSourcesInfo();
		}

		addSources(sources, options) {
			return this.getFeature('DataSources').addDataSources(sources, options);
		}

		getActiveDataSourceId() {
			return this.getFeature('DataSources').getActiveDataSourceId();
		}

		setActiveDataSourceId(activeDataSourceId) {
			this.getFeature('DataSources').setActiveDataSourceId(activeDataSourceId);
		}
	}

	/**
	 * factory method
	 * @param {object} options
	 */
	DashboardAPIImpl.create = function(options) {
		return new DashboardAPIImpl(options);
	};

	return DashboardAPIImpl;
});
